import React from 'react';
import { Grid, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const FiltersSection = ({ filters }) => (
    <Grid container spacing={2} sx={{ mb: 4 }}>
        {filters.map(({ label, value, set, options }) => (
            // Each filter is a Grid item that responds to screen size
            <Grid item xs={12} sm={6} lg={2} key={label}>
                <FormControl fullWidth variant="filled">
                    <InputLabel
                        sx={{
                            color: '#aaa',
                            '&.Mui-focused': { color: '#12c099' }
                        }}
                    >
                        {label}
                    </InputLabel>
                    <Select
                        value={value}
                        onChange={(e) => set(e.target.value)}
                        label={label}
                        disableUnderline
                        sx={{
                            backgroundColor: '#2a2a2a',
                            color: '#fff',
                            borderRadius: '4px',
                            '& .MuiSelect-icon': {
                                color: '#fff'
                            }
                        }}
                    >
                        {options.map(opt => (
                            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        ))}
    </Grid>
);

export default FiltersSection;
